import {ResourceParams} from "./resources";
import {
  productCardModalFilesResources, ProductCardModalFilesResourceType,
  productCardModalResources,
  ProductCardModalResourceType
} from "./tables/product-card-resource-types";

export type ModalResourceType =
  'advertisement-documents' |
  'advertisement-initial-statistics' |
  'advertisement-statistics' |
  'bank-details' |
  'blogger-contacts' |
  'bloggers-modal' |
  'files' |
  'audiences' |
  'advertisement-packages' |
  'plan-fact-exceptions' |
  'blogger-profiles' |
  'blogger-groups' |
  'record-lists-repeats' |
  'record-calendars-repeats' |
  'note-files' |
  'notes-change-price' |
  'advertisement-key' |
  ProductCardModalResourceType |
  ProductCardModalFilesResourceType |
  'testing-result-files';

export const modalResources: {
  [key in ModalResourceType]: ResourceParams
} = {
  'advertisement-documents': {
    key: 'advertisement-documents',
    name: 'Документы',
    path: 'advertisement-documents',
  },
  'advertisement-initial-statistics': {
    key: 'advertisement-initial-statistics',
    name: 'Первичная статистика',
    path: 'advertisement-initial-statistics',
  },
  'advertisement-statistics': {
    key: 'advertisement-statistics',
    name: 'Статистика',
    path: 'advertisement-statistics',
  },
  'bank-details': {
    key: 'bank-details',
    name: 'Реквизиты',
    path: 'bank-details',
  },
  'blogger-contacts': {
    key: 'blogger-contacts',
    name: 'Контакты блогера',
    path: 'blogger-contacts',
  },
  'bloggers-modal': {
    key: 'bloggers',
    name: 'Карточка блогера',
    path: 'bloggers',
  },
  'files': {
    key: 'files',
    name: 'Загрузка файла',
    path: 'files'
  },
  'audiences': {
    key: 'audiences',
    name: 'Аудитория канала',
    path: 'audiences',
  },
  'advertisement-packages': {
    key: 'advertisement-packages',
    name: 'Рекламный пакет',
    path: 'advertisement-packages'
  },
  'plan-fact-exceptions': {
    key: 'plan-fact-exceptions',
    name: 'Измение лимита',
    path: 'plan-fact-exceptions'
  },
  'blogger-profiles': {
    key: 'blogger-profiles',
    name: 'Ссылки на профиль блогера',
    path: 'blogger-profiles'
  },
  'blogger-groups': {
    key: 'blogger-groups',
    name: 'Группы блогеров',
    path: 'blogger-groups'
  },
  'record-lists-repeats': {
    key: 'record-lists-repeats',
    name: '',
    path: 'record-lists-repeats'
  },
  'record-calendars-repeats': {
    key: 'record-calendars-repeats',
    name: 'Карта продукта',
    path: 'record-calendars-repeats'
  },
  'note-files': {
    key: 'note-files',
    name: 'Файлы заметки',
    path: 'note-files'
  },
  'notes-change-price': {
    key: 'notes-change-price',
    name: 'Изменение цены',
    path: 'notes-change-price'
  },
  'advertisement-key': {
    key: 'advertisement-key',
    name: 'Тесты ключей',
    path: 'advertisement-key'
  },
  ...productCardModalResources,
  ...productCardModalFilesResources,
  'testing-result-files': {
    key: 'testing-result-files',
    name: 'Результаты тестирования',
    path: 'testing-result-files'
  }
};
